export const paymentMode = {
  CC: 'Credit Card/Debit Card',
  CH: 'Cash/Cheque'
}

export const uomUN = {
  A: 'Not Applicable',
  U: 'Unlimited',
  N: 'Not Covered',
  C: 'Covered',
  B: null
}

export const pkgGapCalcMethod = {
  S: 'Standard Risk Factor',
  I: 'Individual Method'
}
